import React, { useCallback } from 'react';
import {ClientPosition} from '../../../hooks/DragState';

/**
 * Forked from https://github.com/NeoRaider/react-multi-split-pane
 * MIT License
 */

export interface ResizerProps {
   split: 'horizontal' | 'vertical';
   className: string;
   index: number;
   disabled: boolean;

   onDragStarted: (index: number, pos: ClientPosition) => void;
}

const style = { flex: 'none' };

export const Resizer = React.memo(({ disabled, split, className, index, onDragStarted }: ResizerProps) => {
   const handleMouseDown = useCallback(
      (event: React.MouseEvent) => {
         event.preventDefault();

         if (!disabled) {
            onDragStarted(index, event);
         }
      },
      [index, onDragStarted],
   );

   const handleTouchStart = useCallback(
      (event: React.TouchEvent) => {
         event.preventDefault();

         if (!disabled) {
            onDragStarted(index, event.touches[0]);
         }
      },
      [index, onDragStarted],
   );

   const classes = ['Resizer', split, className].join(' ')+((disabled) ? ' Resizer-disabled' : '');

   return (
      <span
         role='presentation'
         className={classes}
         style={style}
         onMouseDown={handleMouseDown}
         onTouchStart={handleTouchStart}
      />
   );
});
Resizer.displayName = 'Resizer';
